import React from 'react';

export default function VisitorDetailPanel({ conversation }) {
  if (!conversation) return null;
  const initials = conversation.visitorName.split(' ').map(p => p[0]).slice(0,2).join('').toUpperCase();
  return <section className="aw-visitor-detail" aria-label="Visitor detail panel">
    <div className="aw-visitor-head"><div className="aw-visitor-avatar">{initials}</div><div><strong>{conversation.visitorName}</strong><small>{conversation.visitorMeta}</small></div></div>
    <div className="aw-visitor-grid">
      <div><span>Session</span><b>{conversation.id}</b></div>
      <div><span>Channel</span><b>{conversation.visitorMeta.includes('WhatsApp') ? 'WhatsApp' : conversation.visitorMeta.includes('Email') ? 'Email' : 'Website'}</b></div>
      <div><span>Priority</span><b>{conversation.priority}</b></div>
      <div><span>Wait time</span><b>{conversation.waitMinutes} min</b></div>
    </div>
    <div className="aw-visitor-contact"><span>Contact</span><b>{conversation.visitorEmail || 'Not captured yet'}</b></div>
  </section>;
}
